var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm no-margin",
          attrs: { title: "밀폐공간작업 상세정보" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    label: "출입사유",
                    name: "closeEntryResaon",
                  },
                  on: { dataChange: _vm.dataChange },
                  model: {
                    value: _vm.supWork.closeEntryResaon,
                    callback: function ($$v) {
                      _vm.$set(_vm.supWork, "closeEntryResaon", $$v)
                    },
                    expression: "supWork.closeEntryResaon",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    label: "밀폐장소의 예상위험",
                    name: "closeExpectedRisk",
                  },
                  on: { dataChange: _vm.dataChange },
                  model: {
                    value: _vm.supWork.closeExpectedRisk,
                    callback: function ($$v) {
                      _vm.$set(_vm.supWork, "closeExpectedRisk", $$v)
                    },
                    expression: "supWork.closeExpectedRisk",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
          [
            _c("c-table", {
              staticClass: "q-mt-md",
              attrs: {
                isTitle: "",
                title: "안전조치 요구사항",
                columns: _vm.grid.columns,
                gridHeightAuto: true,
                data: _vm.supWork.checkResults,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.checkResultEditable,
                contentsField: _vm.contentsField,
              },
              on: { "table-data-change": _vm.tableDataChange },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8" },
          [
            _c(
              "c-mobile-table",
              {
                ref: "entrantsTable",
                staticClass: "q-mt-md",
                attrs: {
                  isTitle: "",
                  title: "입출입자",
                  columns: _vm.grid3.columns,
                  gridHeightAuto: true,
                  data: _vm.supWork.entrants,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.gasEditable,
                  selection: "multiple",
                  rowKey: "sopWorkEntrantId",
                },
                on: { "table-data-change": _vm.setElapsedTime },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.gasEditable
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(작업업체 근무자)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addVendorEntrant },
                            })
                          : _vm._e(),
                        _vm.gasEditable
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(현업)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addEntrant },
                            })
                          : _vm._e(),
                        _vm.gasEditable
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.removeEntrant },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }